import * as React from 'react';
import MessageTemplate from 'ted-ui/build/MessageTemplate';
import TextStyle from '@able/react/dist/TextStyle';
import Spacing from '@able/react/dist/Spacing';
import { OrderDetailsErrorMessagelabels, HelpAndSupport } from '@applications/order-tracker/config/order-tracker-new-common/constants';
import '../../../order-details-new/style.less';
import { refreshPage } from '@applications/order-tracker/utils';
const illoErrorIcon = require('../../../../../../images/illo-error.svg');
import { Application } from '@applications/order-tracker';
import { Links, Components } from '@telstra-connect/order-tracker/activity-tracking';

const trackPrimaryButtonClick = (): void => {
  Application.tracker.trackLink(
    Links.orderDetails.refreshPageButton,
    Components.orderDetailsPage
  );
};

const trackSecondaryButtonClick = (): void => {
  Application.tracker.trackLink(
    Links.orderDetails.newEnquiryButton,
    Components.orderDetailsPage
  );
};

const handlePrimaryButtonClick = (): void => {
  trackPrimaryButtonClick();
  refreshPage();
};

const handleSecondaryButtonClick = (): void => {
  trackSecondaryButtonClick();
};

const OrderDetailsError = () => {
  return (
    <Spacing
        topVLG="spacing5x"
        topVMD="spacing7x"
        topVSM="spacing4x"
        topVXS="spacing3x"
    >
        <MessageTemplate
            content={
            <TextStyle element="p">
                {OrderDetailsErrorMessagelabels.HelperText}
            </TextStyle>
            }
            imageSrc={illoErrorIcon}
            primaryButton={{
            element: 'button',
            label: OrderDetailsErrorMessagelabels.primaryButtonLabel,
            variant: 'HighEmphasis',
            onClick: handlePrimaryButtonClick,
            }}
            secondaryButton={{
            element: 'a',
            label: OrderDetailsErrorMessagelabels.secondaryButtonLabel,
            variant: 'LowEmphasis',
            className: 'custom-secondary-button-xs',
            href: HelpAndSupport.submitEnquiryRoute,
            onClick: handleSecondaryButtonClick,
            }}
            title={OrderDetailsErrorMessagelabels.Title}
            titleHeadingOrder={1}
        />
    </Spacing>
  );
};

export default OrderDetailsError;
